"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GanacheStateManager = void 0;
const statemanager_1 = require("@ethereumjs/statemanager");
class GanacheStateManager extends statemanager_1.DefaultStateManager {
    async getStorageTrie(address) {
        return await this._getStorageTrie({ buf: address });
    }
}
exports.GanacheStateManager = GanacheStateManager;
//# sourceMappingURL=state-manager.js.map